import React from "react";
import styles from "./recordbtn.module.css";

class RecordBtn extends React.Component {
  render() {
    return (
      <div className={styles.recordbtns}>
        <button style={this.props.style} onClick={this.props.onClick}>
          {this.props.btnName}
        </button>
      </div>
    );
  }
}

export default RecordBtn;
